var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactPageBackgroundSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 515,
    viewBox: "0 0 280 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M390.153 257.413C390.153 332.753 328.984 393.921 253.645 393.921C178.305 393.921 117.137 332.753 117.137 257.413C117.137 182.074 178.305 120.905 253.645 120.905C328.984 120.905 390.153 182.074 390.153 257.413Z",
    fill: "#0089AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.043 94.7126L253.645 0L276.067 94.7126H231.043Z",
    fill: "#0089AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M176.69 112.293L165.568 15.6068L219.024 96.8659L176.69 112.293Z",
    fill: "#0089AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.667 147.27L88.0781 60.2705L166.108 118.39L131.667 147.27Z",
    fill: "#0089AD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.353 195.526L30.6777 128.797L123.955 156.601L101.353 195.526Z",
    fill: "#0089AD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3312 251.313L0 212.746L97.2239 207.006L89.3312 251.313Z",
    fill: "#0089AD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2239 307.818L0 302.257L89.3312 263.691L97.2239 307.818Z",
    fill: "#0089AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.776 358.401L30.6777 386.205L101.353 319.475L123.776 358.401Z",
    fill: "#0089AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M166.108 396.61L88.0781 454.729L131.667 367.73L166.108 396.61Z",
    fill: "#0089AD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M219.024 418.135L165.568 499.394L176.69 402.708L219.024 418.135Z",
    fill: "#0089AD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M276.067 420.288L253.645 515L231.043 420.288H276.067Z",
    fill: "#0089AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactPageBackgroundSun);
export default __webpack_public_path__ + "static/media/ContactPageBackgroundSun.be0edb30518dabfc5baff05ca8f0946d.svg";
export { ForwardRef as ReactComponent };